import { normalizePageParam } from "@/lib/helpers/parsers";
import { GET } from "@/lib/methods";
import {
  objectToQueryString,
  removeUndefinedProperties,
} from "@/lib/utilities";
import type { ApiPlatformResponseType } from "@/types/api-platform.type";
import type { CateringCatalog } from "../types/catering-catalog.type";
import type { CateringFiltersType } from "../types/catering-filtes.type";

export const getCaterings = (
  filters: CateringFiltersType = {},
  requestOptions?: RequestInit,
) => {
  const parsedFilters = removeUndefinedProperties(filters);

  const queryString = objectToQueryString({
    ...parsedFilters,
    priceTo: parsedFilters["price[lte]"] ?? undefined,
    priceFrom: parsedFilters["price[gte]"] ?? undefined,
    tags: parsedFilters.tagsSlugs,
    page: normalizePageParam(filters?.page),
  });

  return GET<ApiPlatformResponseType<CateringCatalog>>({
    url: `${process.env.NEXT_PUBLIC_CATALOG_URL}/caterings${queryString}`,
    params: {
      ...requestOptions,
      next: {
        tags: ["caterings", queryString],
        revalidate: 3600,
        ...requestOptions?.next,
      },
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
};

export const getSingleCateringBySlug = (slug: string) => {
  return GET<CateringCatalog>({
    url: `${process.env.NEXT_PUBLIC_CATALOG_URL}/caterings-slug/${slug}`,
    params: {
      next: {
        tags: ["catering", slug],
        revalidate: 3600,
      },
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
};
